import React from 'react';
import { GROUPS, onShift, readiness, rdyLabel, regionOf } from '../../engine/data';
import type { Worker } from '../../engine/data';
import { rdyTone } from '../../engine/scores';
import { Pill } from '../../ui';

export const WorkerHeader: React.FC<{ w: Worker }> = ({ w }) => {
  const reg = regionOf(w);
  const r = readiness(w);
  return (
    <div className='mb-5 flex flex-wrap items-center gap-4'>
      <div className='flex h-14 w-14 items-center justify-center rounded-full bg-muted text-xl font-bold text-muted-foreground'>
        {w.init}
      </div>
      <div>
        <div className='text-xl font-bold'>{w.name}</div>
        <div className='text-[13px] text-muted-foreground'>
          {w.role} · {GROUPS[w.group].name} · {reg ? reg[1].name : ''}
        </div>
      </div>
      <div className='ml-auto flex flex-wrap gap-2'>
        <Pill tone={rdyTone(r)}>{rdyLabel(r)}</Pill>
        {w.wtrFlag && <Pill tone='bad'>WTR Breach</Pill>}
        {onShift(w) && <Pill tone='info'>On Shift</Pill>}
      </div>
    </div>
  );
};
